import { gqlTagGira } from '@atlassian/jira-apollo-gira';

export const JWM_CATEGORY_OPTIONS_FRAGMENT = gqlTagGira`
    fragment JwmCategoryOptionsFragment on JiraWorkManagementCategoryOption {
        id
        color
        option {
            id
            optionId
            value
            isDisabled
        }
    }
`;
